module.exports = __webpack_public_path__ + "static/media/sigbox.c162e9d2.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Pretty_Lashed/gp/sigbox.JPG
// module id = 460
// module chunks = 0